import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { loadAppConfig, resolveApiBaseUrl } from "./utils/config";

const initI18n = async () => {
  try {
    let supportedLanguages: string[] = ['he', 'en-US'];

    const config = await loadAppConfig();
    const apiBaseUrl = resolveApiBaseUrl(config);

    try {
      const resLang = await fetch(`${apiBaseUrl}languages`);
      const data = await resLang.json();
      if (Array.isArray(data)) {
        supportedLanguages = data
          .filter(lang => lang.statusId && typeof lang.code === 'string')
          .map(lang => lang.code.trim());
      }
    } catch (error) {
      console.error('שגיאה בשליפת שפות מהשרת, משתמשים בברירת מחדל:', error);
    }

    await i18n
      .use(HttpApi)
      .use(LanguageDetector)
      .init({
        supportedLngs: supportedLanguages,
        fallbackLng: 'he',
        detection: {
          order: ['localStorage'],
          caches: ['localStorage']
        },
        backend: {
          loadPath: `${apiBaseUrl}Languages/GetCurrentLocales/admin/{{lng}}`,
          // loadPath: '/locales/locale-{{lng}}.json'        
        },
        interpolation: {
          escapeValue: false, // React already escapes values, no need for double escaping
        },
      }
      );

    // Load static JSON files as fallback for missing keys
    try {
      // Load Hebrew static translations
      const heResponse = await fetch('/locales/locale-he.json');
      if (heResponse.ok) {
        const heStatic = await heResponse.json();
        i18n.addResourceBundle('he', 'translation', heStatic, true, false);
      }
    } catch (error) {
      console.warn('Failed to load static Hebrew translations:', error);
    }

    try {
      // Load English static translations
      const enResponse = await fetch('/locales/locale-en-US.json');
      if (enResponse.ok) {
        const enStatic = await enResponse.json();
        i18n.addResourceBundle('en-US', 'translation', enStatic, true, false);
      }
    } catch (error) {
      console.warn('Failed to load static English translations:', error);
    }

  } catch (error) {
    console.error('שגיאה באתחול i18n:', error);
  }
};

export { initI18n };
export default i18n;